import { Button, Divider, Grid, Typography } from "@mui/material"
import moment from "moment"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useSubscription } from "../../../../Hooks/useSubscription"
import { useUser } from "../../../../Hooks/useUser"
import { useReactivateSubscriptionMutation } from "../../../../Redux/api/subscriptionApi"
import { SubscriptionTier } from "../../../../Types/Client"
import { SubscriptionCancelationModal } from "./SubscriptionCancelationModal"
import { ViewPlanSkeleton } from "./ViewPlanSkeleton"
import { useToast } from "../../../../Hooks/useToast"
import { KaziButton } from "../../../../Shared Components/Kazi/KaziButton"

interface ViewPlanProps {
    
}
export const ViewPlan = ( { }:ViewPlanProps ) => {
    /* ******************** Hooks ******************** */
    const [searchParams, setSearchParams] = useSearchParams();
    const { showToast } = useToast();
    const { subscriptions, subscriptionsLoading } = useSubscription();
    const { userSubscription, isUserLoading, locator, invalidateUser, user } = useUser(); 
    const [reactivateSubscription, {isLoading: reactivatedLoading}] = useReactivateSubscriptionMutation();
    /* ******************** Variables ******************** */
    const [open, setOpen] = useState(false);
    // @ts-ignore
    const nextPayment = user?.stripe?.next_payment;
    /* ******************** Functions ******************** */
    const handleChangePlan = () => {
        setSearchParams({mode: 'edit'})
    }
    const handleClose = () => {
        setOpen(false);
    }
    const handleCancel = () => {
        setOpen(true);
    }
    const handleReactivateSubscription = () => {
        reactivateSubscription(locator!)
        .unwrap()
        .then(() =>{
            invalidateUser();
            handleClose();
            showToast({
                text: 'Your subscription has been reactivated.',
            });
        })
        .catch( err => {
            console.error("Error occured while reactivating subscription: ", err)
            showToast({
                text: "Unable to reactivate subscription",
                variant: "error"
            })
        })
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Typography variant="lora-headline-small">Membership</Typography>
            <Grid display={"flex"} flexDirection={"column"}  marginTop={'40px'}>
                <Grid display={"flex"} flexDirection={"column"} width={'100%'}> 
                    <Grid display={"flex"} flexDirection={"row"}  marginBottom={1} sx={{ color: 'black.300'}}>
                        {
                            subscriptionsLoading || isUserLoading ?
                            <ViewPlanSkeleton />
                            :
                            <>
                                <Grid flex={0.5}>
                                    <Typography variant='body-medium'>{userSubscription.title}</Typography>
                                </Grid>
                                <Grid display={"flex"} flexDirection={"column"} flex={0.5} alignItems={'center'}>
                                    <Typography variant='body-medium' color={'primary'}>{userSubscription.price}</Typography>
                                </Grid>
                                <Grid flex={1}>
                                    {/*@ts-ignore*/}
                                    {user?.subscription && nextPayment && 
                                        <Typography variant='body-smaller'>{userSubscription.renew ? 'Next payment' : 'Payment ends'}: {nextPayment}</Typography>
                                    }
                                </Grid>
                                <Grid display={"flex"} flexDirection={"row"} gap={"40px"} flex={1} justifyContent={'flex-end'}>
                                    {userSubscription.tier != SubscriptionTier.Starter && userSubscription.renew && <Button variant='text' onClick={handleCancel}>Cancel plan</Button>}
                                    {
                                        userSubscription.tier != SubscriptionTier.Starter && !userSubscription.renew && 
                                        <KaziButton 
                                            variant='text' 
                                            onClick={handleReactivateSubscription}
                                            text='Reactivate plan'
                                            loading={{
                                                isLoading: reactivatedLoading,
                                                loadingText: 'Reactivating...',
                                                color: "primary"
                                            }}
                                        />
                                    }
                                    <Button variant='outlined' onClick={handleChangePlan}>Change plan</Button>
                                </Grid>
                            </>
                        }
                    </Grid>
                    <Divider />
                </Grid>
            </Grid>
            <SubscriptionCancelationModal 
                open={open}
                handleClose={handleClose}
                tier={userSubscription.tier}
                endDate={userSubscription.endDate!}
            />
        </>
    )
}